import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedServiceService } from '../shared/shared-service.service';

@Component({
  selector: 'app-mobile-responsive',
  templateUrl: './mobile-responsive.component.html'
})
export class MobileResponsiveComponent implements OnInit {

  active : any = true ;
  constructor(public router: Router, private sharedService: SharedServiceService) { 

  }

  ngOnInit() {
    this.active =  this.sharedService.getHideCategoriesFlag();

    this.sharedService.hideCategories.subscribe(data => {
      this.active = !this.active;
    });
    
  }

   //Toggle category for Mobile View 
   hideCategoryMobileView($event) {
    this.active = !this.active;
  //this.router.navigate(['dashboard/panelbaritems']);
  
 }
 
}



// WEBPACK FOOTER //
// ./src/app/mobile-responsive/mobile-responsive.component.ts